import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Course = lazy(() => import('../pages/course/page'));
const Test = lazy(() => import('../pages/test/page'));
const Exam = lazy(() => import('../pages/exam/page'));
const About = lazy(() => import('../pages/about/page'));
const Access = lazy(() => import('../pages/access/page'));
const Trial = lazy(() => import('../pages/trial/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/course',
    element: <Course />,
  },
  {
    path: '/test',
    element: <Test />,
  },
  {
    path: '/exam',
    element: <Exam />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/access',
    element: <Access />,
  },
  {
    path: '/trial',
    element: <Trial />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
